import { Controller } from "@hotwired/stimulus"

/**
 * Mobile off-canvas admin sidebar. Wide screens (xl / 1280px+) keep sidebar docked.
 */
export default class extends Controller {
  static targets = ["sidebar", "backdrop", "menuButton"]

  connect() {
    this._onKeydown = (e) => {
      if (e.key === "Escape" && !this.backdropTarget.classList.contains("hidden")) this.close()
    }
    this._onResize = () => this._onViewportChange()
    window.addEventListener("keydown", this._onKeydown)
    window.addEventListener("resize", this._onResize)
    this._lastDesktop = undefined
    this._onViewportChange()
  }

  disconnect() {
    window.removeEventListener("keydown", this._onKeydown)
    window.removeEventListener("resize", this._onResize)
    document.body.classList.remove("overflow-hidden")
  }

  _isDesktop() {
    return window.matchMedia("(min-width: 1280px)").matches
  }

  _onViewportChange() {
    const desktop = this._isDesktop()
    if (desktop) {
      this.backdropTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      this.sidebarTarget.classList.remove("translate-x-0")
      this._setMenuExpanded(false)
    } else if (this._lastDesktop === true) {
      // Crossed xl breakpoint: desktop → mobile — reset off-canvas (don’t run on every mobile resize).
      this.sidebarTarget.classList.add("-translate-x-full")
      this.sidebarTarget.classList.remove("translate-x-0")
      this.backdropTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      this._setMenuExpanded(false)
    }
    this._lastDesktop = desktop
  }

  _setMenuExpanded(open) {
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
  }

  open(event) {
    event?.preventDefault()
    if (this._isDesktop()) return
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.sidebarTarget.classList.add("translate-x-0")
    this.backdropTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this._setMenuExpanded(true)
  }

  close(event) {
    event?.preventDefault()
    if (this._isDesktop()) return
    this.sidebarTarget.classList.add("-translate-x-full")
    this.sidebarTarget.classList.remove("translate-x-0")
    this.backdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this._setMenuExpanded(false)
  }

  closeIfNavLink(event) {
    if (event.target.closest("a[href]")) this.close()
  }

  toggle(event) {
    if (this.backdropTarget.classList.contains("hidden")) this.open(event)
    else this.close(event)
  }
}
